<template>
  <InfuseTag v-if="!role.tenantId && !role.organisationId" :inline="true">
    <font-awesome-icon :icon="['fal', 'globe']" class="mr-2" />
    <span>{{ getLevelTranslation(role) }}</span>
  </InfuseTag>

  <InfuseTag v-if="role.tenantId" :inline="true">
    <font-awesome-icon :icon="['fal', 'cubes']" class="mr-2" />
    <span>{{ role.tenantName }}</span>
  </InfuseTag>

  <InfuseTag v-if="role.organisationId" :inline="true">
    <font-awesome-icon :icon="['fal', 'cube']" class="mr-2" />
    <span>{{ role.organisationName }}</span>
  </InfuseTag>
</template>

<script setup lang="ts">
import { Role } from '@infuse/iam/role/type';
import { useAssetLevel } from '@infuse/iam/composables';
import { InfuseTag } from '@infuse/ui/components';

const { getLevelTranslation } = useAssetLevel();

defineProps<{
  role: Role;
}>();
</script>
